<template>
  <div class="register">
    <div :class="$store.state.isMobile ? 'h5Login' : 'pcLogin'">
      <pcLoginWarp :contentType="contentType">
        <div slot="inputs" v-show="contentType == 3 && registIndex == 1">
          <div class="title" slot="title" v-show="contentType == 3 && registIndex == 1" >
            <div class="titleShadow"><span class="titleFont">新用户注册</span></div>
          </div>
          <div class="registerInput">
            <span class="point">{{$store.state.isMobile ? '*' : '*'}}</span>
            <el-input v-model="register.phone" placeHolder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)" clearable></el-input>
          </div>
          <div class="registerInput">
            <span class="point">{{$store.state.isMobile ? '*' : '*'}}</span>
            <el-input auto-complete="new-password" v-model="register.verCode" placeHolder="请输入验证码" type="number" oninput="if(value.length>6)value=value.slice(0,6)"></el-input>
            <div class="button1" @click="getCode">{{hasCode ? `已发送(${timeNow}s)` : '获取验证码'}}</div>
          </div>
          <div class="registerInput registerPassword">
            <span class="point">{{$store.state.isMobile ? '*' : '*'}}</span>
            <el-input v-model="register.password" placeHolder="请输入密码" :type="flagType" auto-complete="new-password">
              <i slot="suffix" :class="[this.flag?'iconfont el-icon-view':'iconfont el-icon-view eye-close']" @click="getFlag()"></i>
            </el-input>
          </div>
          <div class="passwordNotice">密码要求8-16位，必须为字母、数字和特殊字符的组合</div>
          <div class="registerInput registerPassword">
            <span class="point">{{$store.state.isMobile ? '*' : '*'}}</span>
            <el-input v-model="register.conPassword" placeHolder="请再次输入密码"  :type="confirmflagType"  auto-complete="new-password">
              <i slot="suffix" :class="[this.confirmflag?'iconfont el-icon-view':'iconfont el-icon-view eye-close']" @click="confirmgetFlag()"></i>
            </el-input>
          </div>
          <div class="registerInput">
            <span class="point"></span>
            <el-input v-model="register.name" placeHolder="请输入昵称"></el-input>
          </div>
        </div>
        <div slot="button" v-if="contentType == 3 && registIndex != 2">
          <div @click="toRegister" :class="$store.state.isMobile ? 'buttonNormal' : 'buttonSumbit'">立即注册</div>
          <div class="textButton textButtons">           
            <div></div>
            <div @click="toLogin" style="text-align: right;">返回登录页</div>
          </div>
          <!-- <div class="registerAgreement">注册即表示同意<span @click="noticeType = 1;showNotice = true">《隐私政策》</span>和<span @click="noticeType = 2;showNotice = true">《用户协议》</span></div>    -->
        </div>
        <!--注册成功，请登录-->
        <div v-show="contentType == 3 && registIndex == 2" slot="inputs" class="successReset">
          <img src="../../assets/images/complete.png" :class="$store.state.isMobile?'resetPhoneSuccessImg':'resetSuccessImg'">
          <!--<img v-else src="../../assets/ticket/wbs1.png" class="resetSuccessImg">-->
          <div class="successResetFont">恭喜您已注册成功，快去登录吧！</div>
          <div @click="toLogin" class="buttonSumbit">去登录</div>
        </div>  
      </pcLoginWarp>
    </div>
  </div>
</template>

<script>
import pcLoginWarp from '../../components/ticket/pcLoginWarp.vue'

export default {
  data() {
    return {
      register: {
        phone: '',
        password: '',
        verCode: '',
        conPassword: '',
        name: ''
      },
      contentType: 3,
      hasCode: false,
      timeNow: 60,
      timeInterval: '',
      registIndex: 1,
      //密码小眼睛切换
      flag: false,
      flagType: 'password',
      confirmflag: false,
      confirmflagType: 'password',
      showNotice: false,
      noticeType: 1
    };
  },

  components: {pcLoginWarp},

  methods: {
    getCode() {
      // let num = 19814925020
      if (this.hasCode) return
      this.$ajax(`/api/message/send/verification-code?phoneNumber=${this.register.phone}`).then((res) => {
        this.hasCode = true
        this.timeGo()
      })
    },

    timeGo() {
      this.timeInterval = setInterval(() => {
        this.timeNow --
      }, 1000)
    },

    toHome() {
      this.loginIn()
      this.$router.push({path: '/ticket/home', query: this.$route.query})
    },

    toRegister() {
      if (!this.register.phone) {
        return this.$message.warning('请填写手机号')
      }
      if (!this.register.verCode) {
        return this.$message.warning('请填写验证码')
      }
      if (!this.register.password || !this.register.conPassword) {
        return this.$message.warning('请填写密码')
      }
      if (this.register.password != this.register.conPassword) return this.$message.error('两次密码输入不一致！')
      !isNaN(Number(this.$route.query.museumCode)) ? this.register.fid = this.$route.query.museumCode : this.register.museumCode = this.$route.query.museumCode
      this.$ajax.post('/api/auth/jwt/registered', this.register).then((res) => {
        // this.$message.success('注册成功，请登录')
        // let query = this.$route.query
        // query.loginType = 1
        // this.$router.push({path: '/ticket/login', query})
        this.contentType = 3;
        this.registIndex = 2
      })
    },
    
    toLogin() {
      let query = this.$route.query
      query.loginType = 1
      this.$router.push({path: '/ticket/login', query})
    },
    //密码小眼睛切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password'
    },
    confirmgetFlag() {
      this.confirmflag = !this.confirmflag
      this.confirmflagType = this.confirmflag ? 'text' : 'password'
    },
  },

  created() {
  },

  computed: {
  
  },

  watch: {
    timeNow(val) {
      if (val == 0) {
        clearInterval(this.timeInterval)
        this.hasCode = false
      }
    }
  },
}
</script>

<style lang="scss">
.register{
  // font-family: STZHONGS;
  .registerInput{
    width: 100%;
    margin:auto;
    position: relative;
    .point{
      position:absolute;
      left:-.1rem;
      top:.15rem;
      font-size:.1rem;
    }
    .button1{
      position: absolute;
      top: 50% !important;
      right: 0.08rem !important;
      border:0;
      padding: 0 0.06rem;
      height: 0.2rem;
      line-height: .2rem;
      margin-top: -0.1rem;
      width: auto;
      &::before{
        content:'';
        position:absolute;
        width:1px;
        height:40%;
        background:#90323D;
        top:30%;
        left:-.02rem
      }
    }
  }
  .registerAgreement{
    color:#CACACA ;
    font-size: 12px;
    margin-top:14px;
    span{
      color:#90323D;
      cursor: pointer;
    } 
  }

  .registerInput .el-input__inner{
    width: 100%;
    margin: 0.06rem 0;
    padding: 0.05rem 0.01rem 0.05rem 0.12rem;
    padding-right: 1rem;
    height: 0.26rem;
    border: unset;
    font-size: 14px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 999px;
    color: #333;
    font-family: STZHONGS;
  }
  .registerPassword .el-input__suffix{
    background:none;
    font-size:.1rem;
    .el-icon-view:before{
      color:#C0C4CC;
    }
    .eye-close:before{
      background: url('~@/assets/images/eye-close.svg') center/100% 100% no-repeat;
      content:'';
      display:block;
      width:.1rem;
      height:.1rem;
      margin-top:3px
  }
  }
  .passwordNotice{
    font-size: 12px;
    color: #CACACA;
    text-align: left;
    margin: 0;
  }
  .buttonNormal{
    margin: auto;
    margin-top: 0.5rem;
  }
  .buttonSumbit{
    position: relative;
    width: 100%;
    text-align: center;
    height:.26rem;
    // background: #3A5268;
    border-radius: 999px;
    line-height: .26rem;
    font-size: .095rem;
    letter-spacing: 4px;
    margin-top:.12rem;
  }
  .textButton{
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.1rem;
      margin-top: 0.1rem;
      font-size: 0.12rem;
      font-size: 14px;
      cursor: pointer;
      letter-spacing: 0.01em;
      text-decoration-line: underline;
      color: #6C6C6C;
      &.newRegister{
        justify-content: center;
        font-size: 0.18rem;
        font-weight: bold;
      }
    }
    .successResetFont{
      font-size:.08rem;
      margin-bottom:.2rem
    }
}

.register .h5{
  .loginContent{
    position:relative;
    .eye-close:before {
        background: url(../../assets/images/eye-close.svg) center 100% 100% no-repeat;
        content: '';
        display: block;
        width: 0.4rem;
        height: 0.4rem;
        margin-top: 3px;
    }
  }
  .passwordNotice{
    font-size: 0.286rem;
    color: #CACACA;
    text-align: left;
    margin: 0.2rem 0 0.1rem 0;
  }
  .loginContent {
    .point{
      left:-.4rem;
      top:.4rem;
      font-size:.4rem;
      color: #BB313B;
    }
    .registerInput{
      margin-bottom:.1rem
    }
    .el-input{
      display: block !important;
      margin-bottom:0;
      .el-input__inner{
        height:1.2rem;
        border-radius:0;
        padding:0;
        font-size:.4rem;
        margin:0;
      }
      .el-input__suffix{
        width: 0.5rem;
        background-size: 0.4rem 0.4rem;
        font-size:.38rem
      }
    }
    .registerInput .button1{
      height: 100%;
      line-height: 1.2rem;
      right: 0.2rem  !important;
      position: absolute;
      border-radius: 0.6rem;
      padding: 0 0.4rem;
      // color: #90323D;
      font-size: 0.35rem;
      top: 0rem !important;
      background: none;
      border: 0;
      width: auto;
      padding-right: 0;
      margin-top:0 !important;
      &::before {
          position: absolute;
          content: '';
          width: 1px;
          height: 0.3rem;
          background-color: #90323D;
          left: 0;
          top: 50%;
          margin-top: -0.15rem;
      }
    }
    .buttonNormal {
        cursor: unset;
        width: 100%;
        height: 1.25rem;
        line-height: 1.25rem;
        // background-color: #3A5268;
        border-radius: 2rem;
        color: #fff;
        font-size: 0.47rem;
        margin-top: .7rem;
        margin-bottom:.4rem;
    }
    .resetPhoneSuccessImg{
      margin-top:1rem;
      margin-bottom:.7rem
    }
    .successResetFont{
      font-size:.4rem
    }
    .buttonSumbit{
      width: 100%;
      height: 1.25rem;
      line-height: 1.25rem;
      background-color: #3A5268;
      border-radius: 2rem;
      color: #fff;
      font-size: 0.47rem;
      margin-top: 2.4rem;
    }
    .registerAgreement{
      position:absolute;
      width:100%;
      text-align: center;
      left:0;
      bottom:-1rem
    }
  }
}
</style>
<style type="text/css" lang="scss">
  .logoContent .el-input__inner{
    width: 100%;
    margin: 0.06rem 0;
    padding: 0.05rem .01rem .05rem 0.15rem;
    padding-right: 1rem;
    height: 0.26rem;
    border: unset;
    font-size: 14px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 999px;
    color:#333;
    font-family: STZHONGS;
  }

  .registerInput .el-input__suffix .el-icon-circle-close::before{
    display: none;
  }
  .registerInput .el-input__suffix{
    background:url(../../assets/images/close.svg) no-repeat center right;
    background-size:.1rem .1rem;
    top:0;
    right:.1rem;
    font-size:.14rem;
    display: flex;
    align-items: center;
    position: absolute;
  }

  .resetPhoneSuccessImg{
    width: 1.7rem;
    height: 1.7rem;
    margin-bottom: 0.7rem;
    margin-top: 1.5rem;
  }
  .resetSuccessImg{
    width: .4rem;
    margin-bottom: 0.15rem;
    margin-top:.2rem;
  }
  .register .pcLogin{
    .registerInput .el-input__inner{
      height: 45px;
      padding-right: 120px;
      margin: 8px 0;
      padding: 6px 2px 6px 20px;
    }
    .registerInput{
      .button1{
        right: 12px !important;
        height: 20px;
        line-height: 20px;
        margin-top: -10px;
      }
    }
    .buttonSumbit{
      height: 50px;
      line-height: 50px;
      font-size: 18px;
    }
    .registerPassword .el-input__suffix{
      .eye-close:before{
        width:17px;
        height:17px;
      }
    }
  }
  
</style>
